module.exports = __webpack_public_path__ + "img/xmsb6.c261d5a5.png";